<script context="module">
  import PageHead from "./../Components/PageHead.svelte";
  import AdditionalHelp from "./../Components/AdditionalHelp.svelte";
  import Breadcrumb from "./Partials/Breadcrumb.svelte";
  import Alerts from "../Shared/Alerts.svelte";
  export { default as layout } from "../Shared/Layout.svelte";
</script>

<script>
  import { inertia, useForm } from "@inertiajs/svelte";
  import ReminderFaq from "../FAQ/ReminderFaq.svelte";

  const form = useForm("reminderSearchForm", {
    dln: null,
    first_name: null,
    last_name: null,
  });

  function handleSubmit() {
    $form.clearErrors();
    $form.post(route("reminders.lookup"));
  }

  let DebugComponent;

  if (import.meta.env.VITE_MOCK == "true") {
    import("../../Debug/Debug.svelte").then((module) => {
      DebugComponent = module.default;
    });
  }
</script>

{#if import.meta.env.VITE_MOCK == "true"}
  {#if DebugComponent}
    <svelte:component
      this={DebugComponent}
      formData={form}
      include="Reminder"
    />
  {/if}
{/if}

<PageHead>
  <svelte:fragment slot="title">Renewal Reminders</svelte:fragment>
  <svelte:fragment slot="tagline">
    You may sign up for renewal reminders via text message or email. To view or
    change your reminders, sign in using the form below.
  </svelte:fragment>
  <Breadcrumb slot="breadcrumb">
    <span slot="home"></span>
    <span slot="reminders"></span>
  </Breadcrumb>
</PageHead>

<div class="row">
  <div class="col-md-8">
    <div class="card">
      <div
        class="card-body row align-items-center justify-content-center text-center g-0"
      >
        <Alerts {form} />
        <Alerts />
        <p>Enter your Driver's License Number and Name to begin.</p>
        <div class="col-8">
          <div class="form-floating">
            <input
              type="text"
              class="form-control"
              id="first_name"
              placeholder="John"
              class:is-invalid={$form.errors["first_name"]}
              bind:value={$form.first_name}
            />
            <label for="first_name" class="form-label">First Name</label>
            {#if $form.errors["first_name"]}
              <div class="invalid-feedback">
                {$form.errors["first_name"]}
              </div>
            {/if}
          </div>
          <div class="form-floating mt-2">
            <input
              type="text"
              class="form-control"
              id="last_name"
              placeholder="Smith"
              class:is-invalid={$form.errors["last_name"]}
              bind:value={$form.last_name}
            />
            <label for="last_name" class="form-label">Last Name</label>
            {#if $form.errors["last_name"]}
              <div class="invalid-feedback">
                {$form.errors["last_name"]}
              </div>
            {/if}
          </div>
          <div class="form-floating mt-2">
            <input
              type="text"
              class="form-control"
              id="dln"
              placeholder="00000000"
              class:is-invalid={$form.errors["dln"]}
              bind:value={$form.dln}
            />
            <label for="dln" class="form-label">Driver's License #</label>
            {#if $form.errors["dln"]}
              <div class="invalid-feedback">
                {$form.errors["dln"]}
              </div>
            {/if}
          </div>
        </div>

        <div class="text-center mt-2">
          <button
            class="btn btn-outline-secondary"
            use:inertia={{
              href: window.route("home"),
              preserveState: true,
            }}
            id="button-addon2">Cancel</button
          >
          <button
            class="btn btn-success"
            type="submit"
            on:click|preventDefault={handleSubmit}
            disabled={$form.processing}>Submit</button
          >
        </div>
      </div>
    </div>
  </div>

  <div class="col-md-4 mt-4 mt-md-0">
    <ReminderFaq />
    <AdditionalHelp />
  </div>
</div>
